import React, { useCallback, useContext } from "react";
import { NotificationEmail, NotificationEmailListMaxLength } from "../../../../domain/user/notification/NotificationEmail";
import { NotificationEmailContext } from "../../../provider/NotificationEmailProvider";
import { AddIcon } from "../../common/icons/AddIcon";

export const AddEmailButton = React.memo(function AddEmailButton() {
    const {
        notificationEmailList,
        setNotificationEmailList
    } = useContext(NotificationEmailContext);

    const handleEmailListAddClicked = useCallback(() => {
        if (!(notificationEmailList.length < NotificationEmailListMaxLength)) {
            alert(`通知先は最大${NotificationEmailListMaxLength}件です。`);
            return;
        }

        setNotificationEmailList(prev => [...prev, NotificationEmail.fromNothing()]);
    }, [notificationEmailList, setNotificationEmailList]);

    return (
        <div className="add_email_row">
            <div className="add_email" onClick={handleEmailListAddClicked}>
                <div className="add_email__icon">
                    <AddIcon />
                </div>
                <span className="add_email__text">メールアドレスを追加する</span>
            </div>
        </div>
    );
});
